'use strict';

define('globalFunctions', ['jquery', 'app', 'commonModule', 'siteObj'], function ($, app, commonModule, siteObj) {
  'use strict';

  return function () {
    // track buy button clicks
    function buyButtonTrack(button) {
      var $body = $('body');

      if (!button.parents('.bp-cross-sell').length) {
        // Don't apply this event tracking to Ajax basket cross-sell products as they have their own
        // tracking.
        var btext = $.trim(button.text());
        // get the button text so we can differentiate between Buy Now and Pre-Order
        var pagetype = $body.attr('class').split(' ', 1);

        // split the body class incase it contains more than one

        if (pagetype === '') {
          pagetype = 'No Dept';
        }

        if (btext === '') {
          btext = 'Misc';
        }
        app.publish('tracking/record', pagetype[0], 'Buying', btext);

        //tracking to show if product added from overlay on basket page
        if (siteObj.page === 'basket') {
          try {
            var element = button[0];
            var formSku = $(element).closest('form').attr('action');
            var productText = $('.product-quick-view .line h2').text().split('£')[0];
            var product = $.trim(productText);
            var sku = formSku.split('.')[0];
            var qty = $('.qty-picker').val();
            var productPrice = $('.product-quick-view .line h2.price').text().split('£')[1];
            var totalPrice = productPrice * qty;
            app.publish('tracking/record', 'Basket | Recommendation', 'Add to Basket', product + ' | ' + sku + ' | ' + qty, totalPrice);
          } catch (e) {
            app.publish('tracking/record', 'gtmEventsError', 'Basket Quickview ATB', e.message);
          }
        }

        siteObj.fn.log(['_trackEvent', pagetype[0], 'Buying', btext]);
      }
    }
    return {
      // Logging func for debugging and error throwing.
      log: function log(message, type) {
        commonModule.log(siteObj, message, type);
      },

      // Returns query string parameters from a URL as a JS object. Although this is
      // specifically for URLs it also can be used on any string with "?param=val" notation.
      get_uri_params: function get_uri_params(str) {
        return commonModule.get_uri_params(str);
      },

      // Returns a specific parameter from a set of query string parameters.
      get_uri_param: function get_uri_param(str, param) {
        // Convert query string param to an object.
        var obj = this.get_uri_params(str);

        return obj.hasOwnProperty(param) ? obj[param] : false; // Returns false if param isn't
        // present.
      },

      gaEventTrack: function gaEventTrack(category, action, label, data, url) {
        commonModule.gaEventTrack(category, action, label, data, url);
      },

      loadScript: function loadScript(url) {
        commonModule.loadScript(url);
      },
      cookies: {
        create: function create(name, value, exdays, path) {
          var exdate = new Date();
          var p_value = '';
          exdate.setDate(exdate.getDate() + exdays);
          var c_value = escape(value) + (exdays === null ? '' : '; expires=' + exdate.toUTCString());
          if (path) {
            /* Path used when cookie needs to persist through whole site typical value would be '/' */
            p_value = ';path=' + path + ';';
          }
          document.cookie = name + '=' + c_value + p_value;
        },
        read: function read(name) {
          var x;
          var y;
          var ARRcookies = document.cookie.split(';');

          // Create array of cookies
          for (var i = 0; i < ARRcookies.length; i++) {
            // Split contents of cookie into Key / Value
            // Key
            x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
            // Value
            y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
            x = x.replace(/^\s+|\s+$/g, '');
            // If correct cookie recieved
            if (x === name) {
              siteObj.fn.log(unescape(y));
              return unescape(y);
            }
          }
        }
      },

      // Basket utility funcs.
      basket: {

        loading: window.location.protocol === 'http:' ? $('<img />', {
          'src': siteObj.siteNonSecureURL + siteObj.loadingGifPath,
          'alt': '',
          'class': 'vars-loading' // Required for positioning with CSS.
        }) : $('<img />', {
          'class': 'vars-loading' // Required for positioning with CSS.
        }),

        // An array to save the selected options as we go.

        selected_opts_arr: [],

        preselected_product: false,

        // Look for price component classes if legacy selectors return falsey
        original_price: $('.productoptions').find('.price').html() || $('.productoptions').find('.priceBlock_current_price').html(),
        original_saving_amount: $('.productoptions').find('.saving-amount').html() || $('.productoptions').find('.priceBlock_saving').html(),
        original_saving_percent: $('.productoptions').find('.saving-percent').html(),
        original_price_rrp: $('.productoptions').find('.price-rrp').html() || $('.productoptions').find('.priceBlock_was').html(),

        // Check if the element only has one option and trigger "change" if it does.
        preSelector: function preSelector($prod_opts, idx, blockCall) {
          if (this.preselected_product === true) {
            $prod_opts.find('.field:eq(' + idx + ') select').trigger('change');
          } else if (!blockCall && $prod_opts.find('.field:eq(' + idx + ') select option').length === 2) {
            $prod_opts.find('.field:eq(' + idx + ') select:first').find('option:nth-child(2)').attr('selected', true).trigger('change');
          }
        },

        build_data: function build_data($prod_opts, idx, isRadio) {
          var i = 0;
          var selected_opts;
          var selected_str = 'selected=';
          // Run through all currently enabled select elements and
          // build up the data string to pass into the Ajax request.
          if (isRadio) {
            // selected=1&variation1=4&option1=18117"
            i = 1;
            $prod_opts.find('input[type=\'radio\']').each(function () {

              if ($(this).attr('checked') === 'checked') {
                $(this).siblings('.subscriptions__label').addClass('checked');
                selected_opts = '&variation1' + '=' + $(this).attr('data-opts') + '&option1' + '=' + $(this).val();
                return;
              } else {
                $(this).siblings('.subscriptions__label').removeClass('checked');
              }
            });
          } else {

            selected_opts = $prod_opts.find('.field:lt(' + idx + ') select, .field:eq(' + idx + ') select').map(function () {
              var $this = $(this);
              var id = $this.attr('id').replace(/^opts-/, ''); // Id of the variation.
              var opt = $this.find('option:selected').val(); // Selected option for that variation.

              // Increment "i" by one for use below.
              i++;

              return '&variation' + i + '=' + id + '&option' + i + '=' + opt;
            }).get().join(''); // Use .get() to return a native JS array and .join() to convert to
            // a string.
          }

          // Return the data string.
          return selected_str + i + selected_opts;
        },

        // Applies the returned into the relevant area in the product page.
        apply_variation_options: function apply_variation_options($field, opts) {

          var $prod_opts = $field.parents('.productoptions').first();
          var $next_form = $field.next();
          var idx = $prod_opts.find('.field').index($next_form);
          // Check some options have been returned before
          // we try to process them to avoid any JS errors.
          if (opts && $.isArray(opts)) {

            // Create all the required <option /> tags and append them into the relevant select box.
            if (this.preselected_product === false) {
              $next_form.find('select option').slice(1) // Find all options excluding the first "Please select..." option...
              .remove(); // And remove them.
            } else {
              $next_form.find('select option').remove(); // And remove them.
            }

            if ($next_form.closest('.js-product-quick-view.mp').length) {
              $next_form.find('select').show().html('').append(function () {
                return $.map(opts, function (option) {
                  return '<option value="' + option.id + '" rel="' + option.value + '">' + option.name + '</option>';
                }).join('');
              }).removeClass('disabled').removeAttr('disabled'); // Enable the select el once
              // complete.
            } else {
              $next_form.find('select').show().append(function () {
                return $.map(opts, function (option) {
                  return '<option value="' + option.id + '" rel="' + option.value + '">' + option.name + '</option>';
                }).join('');
              }).removeClass('disabled').removeAttr('disabled'); // Enable the select el once
              // complete.
            }

            // render select lists with only one option to look like labels
            /* roll-back change until the new year (2017)
             var select = $field.find("select");
             if (select.length && select[0].options) {
             if (select[0].options.length === 1) {
             select[0].classList.add("one-item-select");
             } else {
             select.removeClass("one-item-select");
             }
             }
             */

            if (this.selected_opts_arr.length && $next_form.find('option[value=\'' + siteObj.fn.basket.selected_opts_arr[idx] + '\']').length) {
              $next_form.find('select').val(this.selected_opts_arr[idx]).trigger('change');
              return false;
            } else {
              this.variation_select(idx, this.original_price, this.original_saving_amount, this.original_saving_percent, this.original_price_rrp, $prod_opts);
              return true;
            }
          }
        },

        variation_select: function variation_select(idx, original_price, original_saving_amount, original_saving_percent, original_price_rrp, $prod_opts) {

          var counter = 0;

          if ($('body').hasClass('list') || $('body').hasClass('searchlist') && original_price === null) {
            original_price = $('.product-price').data('original_price');
          }

          $('select option:selected').each(function () {
            if ($(this).attr('value') !== '' && $(this).attr('value') !== null) {
              counter++;
            }
          });

          if (idx + 1 !== counter) {

            $prod_opts.find('.price').html(siteObj.fn.basket.original_price).end().find('.priceBlock_current_price').html(siteObj.fn.basket.original_price).end().find('.saving-amount').html(siteObj.fn.basket.original_saving_amount).end().find('.priceBlock_saving').html(siteObj.fn.basket.original_saving_amount).end().find('.saving-percent').html(siteObj.fn.basket.original_saving_percent).end().find('.price-rrp').html(siteObj.fn.basket.original_price_rrp).end().find('.priceBlock_was').html(siteObj.fn.basket.original_price_rrp).end().find('.buynow').addClass('disabled');

            if ($('.productoptions').find('.quantitybox').hasClass('hidden')) {
              $('.productoptions').find('.quantitybox').hide();
            }
            // call variationsCallback Function if it exists
            if (siteObj && siteObj.variationsCallback && typeof siteObj.variationsCallback === 'function') {
              siteObj.variationsCallback();
            }
          }
        },

        getSubscriptionOptions: document.querySelectorAll('.variation-dropdowns select'),
        pricePerMonth: document.querySelector('.js-price-per-month span'),

        /**
         * Check for subscription data to update
         * @param data
         */
        setSubscriptionInformation: function setSubscriptionInformation(data) {
          // Check last dropdown has value
          if (this.pricePerMonth) {
            if (this.getSubscriptionOptions[this.getSubscriptionOptions.length - 1].value && data) {
              if (data.pricePerMonth) {
                this.pricePerMonth.innerHTML = data.pricePerMonth;
              }
              app.element.removeClass('hide', this.pricePerMonth.parentNode);
            } else {
              app.element.addClass('hide', this.pricePerMonth.parentNode);
            }
          }
        },

        // Fetch variations JSON with Ajax
        fetch_variations: function fetch_variations(data, $field, variationCount) {
          var $prod_opts = $field.parents('.productoptions').first();
          var idx = $prod_opts.find('.field').index($field);
          var variationsUrl = '';

          if (siteObj.page === 'basket' && siteObj.section === 'checkout') {
            variationsUrl = siteObj.siteSecureURL + 'variations.json?productId=' + $prod_opts.find('input[name=\'buy\']').val();
          } else {
            variationsUrl = siteObj.siteNonSecureURL + 'variations.json?productId=' + $prod_opts.find('input[name=\'buy\']').val();
          }
          // Show loading spinner.
          siteObj.fn.basket.loading.appendTo($field).show();

          $.ajax({
            cache: false,
            type: 'POST',
            url: variationsUrl,
            dataType: 'json',
            data: data,
            success: function success(result) {

              //Display price per unit
              if (siteObj.pricePerUnit === 'true') {
                this.displayPricePerUnit(result);
              }

              var variationBlock = document.querySelector('.product-variation') || document.querySelector('.product-variations');
              var theSelectors = variationBlock.querySelectorAll('select');
              var selectorCount = theSelectors.length; // this will get the selectors after every successful ajax call unfortunately
              var variationsDone = false;
              var jZoomImageLinks = document.querySelector('.jZoom_imageLinks');

              if (idx + 1 === selectorCount) {
                variationsDone = true;
              }

              siteObj.productImages = result.images;

              var availabilityMessagePrefix = document.querySelector('[data-target="variation-stock-message-prefix"]');
              var availabilityMessageSuffix = document.querySelector('[data-target="variation-stock-message-suffix"]');

              if (availabilityMessagePrefix && result.availabilityPrefix) {
                availabilityMessagePrefix.textContent = result.availabilityPrefix;
              }

              if (availabilityMessageSuffix && result.availabilitySuffix !== null) {
                availabilityMessageSuffix.textContent = result.availabilitySuffix;
              }

              // changes the colour swatch block
              if (($field.parents('.product-area').length || $field.parents('.product-content').length) && window.colourPicker && $('.product').length === 1 && result.images && result.images.length) {
                $('.colour-swatch').removeClass('colour-swatch-selected');
                var selectChange = $('.colour-swatches-variants-selectbox option:selected').attr('value');
                $('li[rel=\'' + selectChange + '\']').toggleClass('colour-swatch-selected');
              }

              var currentProductPageImageSize = function currentProductPageImageSize(currentMainImage, productLargeViewMainImage, productThumbnailImage, zoomThumbnailImage) {

                var productImages = {};
                var imageTest = null;
                var productImageSize = '';
                var mainImageSrc = '';
                var productLargeViewMainImageSrc = '';
                var zoomImageSize = '';
                var productThumbnailSize = '';
                var productThumnailImageSrc = '';
                var zoomThumbnailImageSrc = '';
                var zoomThumbnailSize = '';
                var imageSizes = {
                  'thumbnail': '70/70',
                  'smallprod': '100/100',
                  'largeproduct': '300/300',
                  'carousel': '480/480',
                  'extralarge': '600/600',
                  'zoom': '960/960'
                };

                var getCurrentImageSize = function getCurrentImageSize(imageToTest) {

                  var newImage = '';

                  if (imageToTest) {
                    for (var prop in imageSizes) {
                      imageTest = imageToTest.indexOf(imageSizes[prop]);
                      if (imageTest > -1) {
                        newImage = prop;
                        break;
                      }
                    }
                  }

                  return newImage;
                };

                if (currentMainImage) {
                  mainImageSrc = currentMainImage.getAttribute('src');
                }

                if (productLargeViewMainImage) {
                  productLargeViewMainImageSrc = productLargeViewMainImage.getAttribute('src');
                }

                if (productThumbnailImage) {
                  productThumnailImageSrc = productThumbnailImage.getAttribute('src');
                  productThumbnailSize = getCurrentImageSize(productThumnailImageSrc);
                }

                if (zoomThumbnailImage) {
                  zoomThumbnailImageSrc = zoomThumbnailImage.getAttribute('src');
                  zoomThumbnailSize = getCurrentImageSize(zoomThumbnailImageSrc);
                }

                if (mainImageSrc) {
                  productImageSize = getCurrentImageSize(mainImageSrc);
                }

                if (productLargeViewMainImageSrc) {
                  zoomImageSize = getCurrentImageSize(productLargeViewMainImageSrc);
                }

                if (productImageSize) {
                  productImages.productImageSize = productImageSize;
                  productImages.zoomImageSize = zoomImageSize;
                  productImages.productThumbnailSize = productThumbnailSize;
                  productImages.zoomThumbnailSize = zoomThumbnailSize;
                } else {
                  productImages = {
                    productImageSize: 'largeproduct',
                    zoomImageSize: 'extralarge',
                    productThumbnailSize: 'thumbnail',
                    zoomThumbnailSize: 'thumbnail'
                  };
                }

                return productImages;
              };

              var createObjectArray = function createObjectArray(object, newArray, childArraySuffix, itemValue, childArrayName) {

                newArray = [];

                if (object) {
                  var objectLength = object.length;

                  for (var i = 0; i < objectLength; i++) {
                    if (object[i][itemValue]) {

                      //does the array to hold the images exist? if not make it
                      if (!newArray[object[i][childArrayName] + childArraySuffix]) {
                        newArray[object[i][childArrayName] + childArraySuffix] = [];
                      }
                      newArray[object[i][childArrayName] + childArraySuffix].push(object[i][itemValue]);
                    }
                  }
                }

                return newArray;
              };

              var checkPageThumbs = function checkPageThumbs(thumbnails, imageArray) {
                var thumbnailExists = false;

                if (thumbnails && imageArray) {
                  var firstThumbnailUrl = imageArray.thumbnail[0].split('/');
                  var thumbnailName = firstThumbnailUrl[firstThumbnailUrl.length - 1].split('.')[0];
                  var l = thumbnails.length;

                  for (var i = 0; i < l; i++) {

                    if (thumbnails[i].getAttribute('src').indexOf(thumbnailName) > 0) {
                      thumbnailExists = true;
                      break;
                    }
                  }
                }
                return thumbnailExists;
              };

              var createAndAppendThumbnail = function createAndAppendThumbnail(imageArray) {
                var currentMainImage = document.querySelector('[data-main-product-image]');
                var productLargeViewMainImage = document.querySelector('[data-product-large-view-main-image]');
                var productPageThumbs = document.querySelectorAll('[data-product-thumb-image]');
                var thumbsLength = productPageThumbs.length;

                if (thumbsLength < 2 || checkPageThumbs(productPageThumbs, imageArray) !== false) {
                  return false;
                }

                var zoomThumbnailImage = document.querySelector('[data-product-large-view-thumb-image]');
                var productImageSizeObject = currentProductPageImageSize(currentMainImage, productLargeViewMainImage, productPageThumbs[0], zoomThumbnailImage);
                var productPageImageSize = productImageSizeObject.productImageSize ? productImageSizeObject.productImageSize : 'largeproduct';
                var productZoomImageSize = productImageSizeObject.zoomImageSize ? productImageSizeObject.zoomImageSize : 'extralarge';
                var productThumbnailSize = productImageSizeObject.productThumbnailSize ? productImageSizeObject.productThumbnailSize : 'thumbnail';
                var productZoomThumbnailSize = productImageSizeObject.zoomThumbnailSize ? productImageSizeObject.zoomThumbnailSize : 'thumbnail';
                var thumbnailsBlock = document.querySelectorAll('[data-product-thumbnail-container]');
                var thumbnailsBlockLength = thumbnailsBlock.length;
                var newThumbnailItems = '';

                if (thumbnailsBlock && thumbnailsBlock.length > 1) {
                  for (var i = 0; i < thumbnailsBlockLength; i++) {

                    var dynamicThumbnailTest = thumbnailsBlock[i].querySelector('[data-dynamic-thumbnail]');
                    if (dynamicThumbnailTest) {
                      dynamicThumbnailTest.parentNode.removeChild(dynamicThumbnailTest);
                    }

                    var thumbnailsLastItem = thumbnailsBlock[i].querySelector('[data-product-thumbnail-item]:last-child');
                    if (thumbnailsLastItem) {
                      newThumbnailItems = thumbnailsLastItem.cloneNode(true);
                      newThumbnailItems.setAttribute('data-dynamic-thumbnail', '');

                      var theImage = newThumbnailItems.querySelector('img');
                      var theLink = newThumbnailItems.querySelector('[data-product-thumbnail-link]');
                      // Need to ensure elements exist so calling hasAttribute on them doesn't throw exception
                      // When we get the thumbnail images back we add the first image to the end fo the thumbnails

                      if (theImage && theLink) {
                        theLink.hasAttribute('data-product-large-thumbnail-link') ? theLink.setAttribute('href', siteObj.productImagePrefix + imageArray[productZoomImageSize][0]) : theLink.setAttribute('href', siteObj.productImagePrefix + imageArray[productPageImageSize][0]);
                        theImage.hasAttribute('data-product-large-view-thumb-image') ? theImage.setAttribute('src', siteObj.productImagePrefix + imageArray[productZoomThumbnailSize][0]) : theImage.setAttribute('src', siteObj.productImagePrefix + imageArray[productThumbnailSize][0]);
                        theImage.setAttribute('rel', thumbnailsBlockLength);
                      }
                      thumbnailsBlock[i].appendChild(newThumbnailItems);
                    }
                  }
                }

                return createAndAppendThumbnail;
              };

              var imageReplace = function imageReplace(imageArray) {

                var currentMainImage = document.querySelector('[data-main-product-image]');
                var mainImageZoomTextLink = document.querySelector('[data-image-zoom-text-link]');
                var mainImageZoomImageLink = document.querySelector('[data-image-zoom-image-link]');
                var productLargeViewMainImage = document.querySelector('[data-product-large-view-main-image]');
                var productImageSizeObject = currentProductPageImageSize(currentMainImage, productLargeViewMainImage);
                var newImageSrc = '';
                var newImageZoomLink = '';
                var currentMainImageSrc = '';
                var productPageImageSize = productImageSizeObject.productImageSize ? productImageSizeObject.productImageSize : 'largeproduct';
                var productZoomImageSize = productImageSizeObject.zoomImageSize ? productImageSizeObject.zoomImageSize : 'extralarge';

                if (currentMainImage) {
                  currentMainImageSrc = currentMainImage.getAttribute('src');
                }

                if (imageArray) {

                  newImageSrc = siteObj.productImagePrefix + imageArray[productPageImageSize][0];
                  newImageZoomLink = siteObj.productImagePrefix + imageArray[productZoomImageSize][0];

                  if (currentMainImage && newImageSrc && currentMainImageSrc && newImageSrc !== currentMainImageSrc) {

                    currentMainImage.setAttribute('src', newImageSrc);

                    if (productLargeViewMainImage) {
                      productLargeViewMainImage.setAttribute('src', newImageZoomLink);
                    }
                    if (mainImageZoomTextLink) {
                      mainImageZoomTextLink.setAttribute('href', newImageZoomLink);
                    }
                    if (mainImageZoomImageLink) {
                      mainImageZoomImageLink.setAttribute('href', newImageZoomLink);
                    }
                  }
                }
                return imageReplace;
              };

              // if no jZoom then we are using imageZoom so fire the next bit
              // and also check the siteObj has references to images
              if (!jZoomImageLinks && siteObj.productImages.length && siteObj.productImages[0].name !== '') {
                var imageArray = createObjectArray(siteObj.productImages, 'imageArray', '', 'name', 'type');
                var changeThumbnail = createAndAppendThumbnail(imageArray);
                var replaceProductImages = new imageReplace(imageArray);
              }

              // For subscription products only
              if (result.pricePerMonth) {
                siteObj.fn.basket.setSubscriptionInformation(result);
              }
              var variations;
              var options;

              // All fields, but the last.
              if (idx + 1 < $prod_opts.find('.field').length) {
                variations = result.variations;
                options = variations[++idx].options || false;
                var options_type = variations[idx].variation || false;
                var callPreselector = true;

                if (options) {
                  // Add the returned variations into the page.
                  callPreselector = siteObj.fn.basket.apply_variation_options($field, options, options_type);
                }

                if (callPreselector) {
                  siteObj.fn.basket.preSelector($prod_opts, variationCount + 1); // Adds 1 to the
                  // count so that
                  // it moves onto
                  // checking the
                  // next form.
                }
              }

              // Check for the last field.
              else {
                  variations = result.variations;
                  options = variations[idx].options || false;

                  if (options) {
                    // Add the returned variations into the page.
                    siteObj.fn.basket.apply_variation_options($field, options);
                  }

                  // Check for bulk discount markup.
                  var bulk = $('[data-component=\'updateBulkBuy\']').find('span');
                  if (bulk.length !== 0) {
                    window.updateBulkBuy(result['bulk-buy']);
                  }

                  var savingAmount = result.rrpSaving;
                  var savingAmountMessage = siteObj.props.ajaxBasket.titles.basketSave + '&nbsp;' + savingAmount;
                  var savingPercent = result.rrpSavingPercent;
                  var savingPercentMessage = siteObj.props.ajaxBasket.titles.basketSave + '&nbsp;<span>' + savingPercent + '</span>';
                  var priceRRPMEssage = siteObj.props.ajaxBasket.titles.basketRRP + '&nbsp;<span class=\'strike\'>' + result.rrpDisplay + '</span>';

                  if (savingPercent === null || savingPercent === '') {
                    savingPercentMessage = '';
                    savingAmountMessage = '';
                    priceRRPMEssage = '';
                  }

                  $prod_opts.find('.price').html(result.price) // Update price.
                  .end().find('.priceBlock_current_price').html(result.price) // Update price (Price component)
                  .end().find('.saving-amount').html(savingAmountMessage) // Update saving
                  .end().find('.priceBlock_saving').html(savingAmountMessage) // Update saving (Price component)
                  .end().find('.saving-percent').html(savingPercentMessage) // Update saving percentage
                  .end().find('.price-rrp') // Update RRP
                  .html(priceRRPMEssage).end().find('.priceBlock_was') // Update RRP (Price Component)
                  .html(priceRRPMEssage);

                  var $qtyBox = $('.buying-area').find('.quantitybox');
                  if ($qtyBox.hasClass('hidden')) {
                    $qtyBox.show();
                  }

                  // Enable the buy button when the final option has been picked.
                  $('.productoptions').find('.buying-area button').removeAttr('disabled').removeClass('disabled');
                }

              siteObj.fn.basket.close_loader();
              if (window.colourPicker && $('.product').length === 1) {
                window.colourPicker();
              }

              if (siteObj.features.enhancedEcommerce === 'true') {
                require(['enhancedEcommerce'], function (enhancedEcommerce) {
                  enhancedEcommerce.productPageVariations(result);
                });
              }

              var images = result.images;
              var hImage = $('[data-product-main-image-variation-images="true"]')[0];

              if (variationsDone && images && siteObj.siteCode === 'myprotein' && hImage) {
                this.productImageVariation(images, hImage);
              }
            },
            productImageVariation: function productImageVariation(images, hImage) {

              var mainProductImageContainer = document.querySelector('.main-product-image');
              //imageZoomLink = mainProductImageContainer.querySelector('.product-img-zoom-action'),
              var mainProductImage = mainProductImageContainer.querySelector('.main-product-image img');
              // var listItems = mainProductImageContainer.querySelectorAll('.list-item');
              var jZoomImages = document.querySelector('.jZoom_imageLinks');
              var productLargeView = document.querySelector('.product-large-view');
              var largeViewMain = productLargeView.querySelector('.product-image');
              var largeViewMainImg = largeViewMain.querySelector('img');
              //unitItems = productLargeView.querySelectorAll('.n-unit'),
              var thumbnailImages = [];
              var carouselImages = [];
              var extralargeImages = [];
              var largeproductImages = [];
              var magnifyImages = [];
              var changeTheImages = false;

              for (var i = 0; i < images.length; i++) {
                if (images[i].name) {
                  switch (images[i].type) {
                    case 'thumbnail':
                      thumbnailImages.push(images[i].name);
                      break;
                    case 'carousel':
                      carouselImages.push(images[i].name);
                      break;
                    case 'extralarge':
                      extralargeImages.push(images[i].name);
                      break;
                    case 'largeproduct':
                      largeproductImages.push(images[i].name);
                      break;
                    case 'magnify':
                      magnifyImages.push(images[i].name);
                      break;
                  }
                }
              }

              var newImage = document.createElement('img');
              newImage.onload = function () {
                if (hImage) {
                  hImage.style.visibility = 'visible';
                }
              };
              var newLargeImageSrc = siteObj.productImagePrefix + largeproductImages[0];
              newImage.setAttribute('src', newLargeImageSrc);
              //var newExtraLargeImageSrc = siteObj.productImagePrefix + extralargeImages[0];


              //check for products with the same first image

              if (!siteObj.productPageMainImage) {
                siteObj.productPageMainImage = newLargeImageSrc;

                var currentMainImageSrc = mainProductImage.getAttribute('src');

                changeTheImages = currentMainImageSrc.substring(currentMainImageSrc.lastIndexOf('/') + 1, currentMainImageSrc.length) !== newLargeImageSrc.substring(newLargeImageSrc.lastIndexOf('/') + 1, newLargeImageSrc.length) || magnifyImages.length > 1;

                var existingThumbItem = document.querySelectorAll('[data-product-thumbnail-container] [data-product-thumbnail-item]');
                for (var i3 = 0; i3 < thumbnailImages.length; i3++) {
                  if (existingThumbItem[i3]) {
                    existingThumbItem[i3].style.visibility = 'visible';
                  }
                }

                if (changeTheImages === false) {
                  return;
                }
              } else {

                changeTheImages = newLargeImageSrc.substring(newLargeImageSrc.lastIndexOf('/') + 1, newLargeImageSrc.length) !== siteObj.productPageMainImage.substring(siteObj.productPageMainImage.lastIndexOf('/') + 1, siteObj.productPageMainImage.length) || magnifyImages.length > 1;

                if (changeTheImages === false) {
                  return;
                }
              }

              mainProductImage.setAttribute('src', newLargeImageSrc);
              largeViewMainImg.setAttribute('src', newLargeImageSrc);

              siteObj.productPageMainImage = newLargeImageSrc;

              //remove jZoom object
              //
              if (jZoomImages) {
                var jZ = document.querySelector('.jZoom_imageLinks');

                if (jZ) {
                  jZ.parentNode.removeChild(jZ);

                  //create jZoom image object
                  window.jZim = document.createElement('div');
                  window.jZim.className = 'jZoom_imageLinks';
                  window.jZim.setAttribute('data-using-xl-image', siteObj.ProductPageExtraLargeImage);

                  window.jZmag = document.createElement('div');
                  window.jZmag.className = 'jZoom_magnify';

                  window.jZex = document.createElement('div');
                  window.jZex.className = 'jZoom_extraLarge';

                  window.jZca = document.createElement('div');
                  window.jZca.className = 'jZoom_carousel';

                  window.jZth = document.createElement('div');
                  window.jZth.className = 'jZoom_thumbnails';
                }
              }

              var thumbs = document.querySelector('.js-product__thumbnails');

              if (thumbs) {
                thumbs.innerHTML = '';

                //change thumbnail and large view images
                for (var i2 = 0; i2 < thumbnailImages.length; i2++) {
                  // var targetItem = $(listItems[i2]);

                  // next remove all the thumbnails and replace them with new ones

                  var thumbOjbect = document.createElement('li');
                  thumbOjbect.className = 'list-item';
                  thumbOjbect.style.visibility = 'visible';

                  var thumbObjectA = document.createElement('a');
                  thumbObjectA.setAttribute('href', siteObj.productImagePrefix + extralargeImages[i2]);

                  var thumbObjectDiv = document.createElement('div');
                  thumbObjectDiv.className = 'product-thumb-box';
                  thumbObjectDiv.setAttribute('data-track', 'product-thumb-box');

                  var thumbObjectImage = document.createElement('img');
                  thumbObjectImage.setAttribute('src', siteObj.productImagePrefix + thumbnailImages[i2]);
                  thumbObjectImage.setAttribute('data-index', i2);
                  thumbObjectImage.className = 'product-img product-img-thumb';
                  thumbObjectImage.setAttribute('alt', siteObj.productTitle + ' Image ' + i2);

                  thumbObjectDiv.appendChild(thumbObjectImage);
                  thumbObjectA.appendChild(thumbObjectDiv);
                  thumbOjbect.appendChild(thumbObjectA);
                  thumbs.appendChild(thumbOjbect);

                  if (jZoomImages) {

                    // var jZlink = document.createElement('div');

                    var jZmagnify = document.createElement('div');
                    jZmagnify.setAttribute('data-j-zoom-image-link-' + i2, '');
                    jZmagnify.setAttribute('data-image-link', magnifyImages[i2]);
                    window.jZmag.appendChild(jZmagnify);

                    var jZextraLarge = document.createElement('div');
                    jZextraLarge.setAttribute('data-j-zoom-image-link-' + i2, '');
                    jZextraLarge.setAttribute('data-image-link', extralargeImages[i2]);
                    window.jZex.appendChild(jZextraLarge);

                    var jZcarousel = document.createElement('div');
                    jZcarousel.setAttribute('data-j-zoom-image-link-' + i2, '');
                    jZcarousel.setAttribute('data-image-link', carouselImages[i]);
                    window.jZca.appendChild(jZcarousel);

                    var jZthumbnails = document.createElement('div');
                    jZthumbnails.setAttribute('data-j-zoom-image-link-' + i2, '');
                    jZthumbnails.setAttribute('data-image-link', thumbnailImages[i2]);
                    window.jZth.appendChild(jZthumbnails);
                  }
                }
              }

              if (jZoomImages) {
                window.jZim.appendChild(window.jZmag);
                window.jZim.appendChild(window.jZex);
                window.jZim.appendChild(window.jZca);
                window.jZim.appendChild(window.jZth);

                document.body.appendChild(window.jZim);

                //jZoom stores its images in the dom so we have to update the overlay with the dorrect image
                //next we have to change the overlay jzoom to be the magnify image from the above
                //set it to the first image in the array

                var jZoomOverlay = document.querySelector('.jZoom_overlay');

                if (jZoomOverlay) {
                  var jZoomOverlayImage = jZoomOverlay.querySelector('img');
                  var jZoomImageLinks = document.querySelector('.jZoom_imageLinks');
                  var jZoomMagnifyBlock = jZoomImageLinks.querySelector('.jZoom_magnify');

                  if (jZoomMagnifyBlock.children[0]) {
                    var jZoomMagnify = jZoomMagnifyBlock.children[0].getAttribute('data-image-link');
                    if (jZoomMagnify) {
                      jZoomOverlayImage.setAttribute('src', siteObj.productImagePrefix + jZoomMagnify);
                    }
                  }
                }
              }
            },

            displayPricePerUnit: function displayPricePerUnit(result) {
              var unitPriceP = $.find('.js-price-per-unit');
              if (unitPriceP) {
                if (result.pricePerUnit) {
                  $(unitPriceP).html(result.pricePerUnit).addClass('active');
                } else {
                  $(unitPriceP).removeClass('active');
                }
              }
            },
            error: function error() {
              siteObj.fn.basket.close_loader();
            }
          });
        },

        // Remove loading spinner function.
        close_loader: function close_loader() {
          this.loading.fadeOut(200, function () {
            $(this).remove();
          });
        },

        // Returns the JSON request URL to add products to the basket
        // based on product ID, item qty and any variations required.
        build_add_url: function build_add_url(product_id, item_qty, variations) {
          // Work out subsite code.

          var subsite_code = siteObj.subsiteCode === null ? '' : siteObj.subsiteCode;
          var siteUrlChange = siteObj.siteNonSecureURL;

          if (siteObj.page === 'basket' && siteObj.section === 'checkout') {
            siteUrlChange = siteObj.siteSecureURL;
          }

          // Begin building the request URL using the product ID, site ID, site locale and subsite
          // code.
          var url = siteUrlChange + 'basketinterface.json?productId=' + product_id + '&siteId=' + siteObj.siteID + '&siteDefaultLocale=' + siteObj.siteDefaultLocale + '&siteSubsiteCode=' + subsite_code;

          // Add in any variations if available.
          url += $.isArray(variations) ? '&variationLength=' + variations.length + '&' + variations.join('&') : '&variationLength=' + variations;
          // Finally, add the item quantity.
          url += '&quantity=' + item_qty;

          return url;
        },

        // Process Ajax to add the item(s) to the basket.
        update_products: function update_products(url, button) {

          var postData = {};
          // FF32 issue - removed 'processData: false' from ajax request and replaced with
          // actual postData length. 'processData: false' originally in as an FF3 fix
          var postDataLength = 2;
          // for egift subscriptions
          if (JSON && JSON.stringify) {
            postDataLength = JSON.stringify(postData).length;
            if (document.querySelector('.eGift_buttonSend') !== null) {
              if (siteObj && siteObj.egift) {
                postData = JSON.stringify(siteObj.egift);
                postDataLength = postData.length;
              }
            }
          }

          // Begin Ajax request.
          $.ajax({
            cache: false,
            type: 'POST',
            contentType: 'application/json; charset=UTF-8',
            url: url, // Use url build from siteObj.fn.basket.build_add_url();
            headers: {
              'Content-Length': postDataLength
            },
            data: postData, // Fix for "411 Length Required" error in FF3.

            // URL was successfully requested and some data has been returned.
            success: function success(data) {
              if ($('.secureqv').length && siteObj.page === 'basket') {
                window.location.reload();
                $(window).scrollTop(0);
              }

              if ($.isPlainObject(data)) {

                // This is specific to the site and is defined in the site local JS file.
                if (siteObj.page !== 'basket') {
                  siteObj.fn.basket.init_basket_update(data);
                }

                buyButtonTrack(button);
                app.publish('BasketItemAdded', data);
              } else {
                if (siteObj.fn && siteObj.fn.basket && siteObj.fn.basket.init_basket_update) {
                  siteObj.fn.basket.init_basket_update(siteObj.props.ajaxBasket.errors.basketError, true);
                }
              }
            },

            // Something went wrong...
            error: function error(xhr, text_status, _error) {
              siteObj.fn.log('json error');
              if (_error || xhr.status === 404 || xhr.status === 500) {
                var errMsg = siteObj.props.ajaxBasket.errors.basketError;
                if (xhr.responseText === 'ajax.basket.error.product.sub.gift.duplicate') {
                  errMsg = siteObj.egift && siteObj.egift.errorMessage || errMsg;
                }
                if (siteObj.fn && siteObj.fn.basket && siteObj.fn.basket.init_basket_update) {
                  siteObj.fn.basket.init_basket_update(errMsg, _error);
                }
              }
            }
          });
        },

        // Returns the item quantity based on whether a
        // quantity picker is available on the page or not.

        // This function will need to be expanded to handle selector context
        // incase we have more than one quantity picker per page, e.g. basket line pickers.
        get_qty: function get_qty($selector) {
          // If a specific element to get the value of has been passed in
          // then use that, otherwise default to $(".qty-picker");
          var $qty_field = $selector ? $($selector) : $('.qty-picker');
          // If a quantity field is a available use its value, otherwise default to 1.
          var qty = $qty_field.length && parseInt($qty_field.val(), 10) > 0 ? parseInt($qty_field.val(), 10) : 1;

          return qty;
        }
      }
    };
  }.bind(this);
});
//# sourceMappingURL=globalFunctions.js.map
